import { put, putResolve, select, takeEvery } from 'redux-saga/effects';
import { UTILITY_NOTIFICATION_CLEAR } from '../../actions/utility-actions';
import * as actions from '../../actions/utility-actions';
import { UserNotification } from '../../models/utilities/user-notification';
import { getNotifications } from '../../selectors/utility-selectors';

/**
 * Saga for getting the application service centers for the portal
 */
export function* clearNotification(action: IReduxAction) {
    // Get our notifications
    const storedNotifications = (yield select(getNotifications)) as UserNotification[];

    // Find our notification
    const existingIndices = storedNotifications.map((itm: UserNotification) => itm.id);

    // clear it right away to make it seem fast
    yield put(actions.resetNotifications([]));

    try {        
        // Make the request to clear the notifications if not local
        const rawResponse = yield putResolve(actions.fetch(`/notifications`, 'DELETE', existingIndices));
    }
    catch (err) {
        console.error(err);
    }
}

export function* getClearNotificationsWatcher() {
    yield takeEvery(UTILITY_NOTIFICATION_CLEAR, clearNotification);
}
